import React, { useState, useRef, useEffect } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import cn from 'classnames';
import Styles from './keyboardStyles.module.scss';
import CustomKeyboard from '@components/common/CustomKeyboard/index';

const MultipleKeyboardInputs = ({
  onSubmit,
  maxLength,
  validate,
  // name,
  inputOptions,
  initialData,
  // containerClass,
  // countryCode
}) => {
  const ref = useRef(null);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const [inputName, setInputName] = useState(initialData.name);
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [typed, setTyped] = useState({});


  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setInputs({
      ...ref.current.input,
      [inputName]: inputVal
    });

    ref.current.setInput(inputVal, inputName);
  };

  const handleSubmit = () => {
    const data = {
      // ...ref.current.input,
      ...inputs,
    };
    validate(data).then(() => {
      onSubmit(data);
    }).catch((err) => {
      setError(err.message);
    });
  };

  const handleBlur = (id) => {
    setSwipedDown(true);
    if (document.querySelector(`#${id}`)) {
      document.querySelector(`#${id}`).blur();
    }
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: ''
    });
    setTyped({
      ...typed,
      [data]: ''
    });
  };

  const closeKeyboard = () => {
    setSwipedDown(false);
  };

  const buttonTheme = {
    '{done}': {
      class: 'bgGreen',
    }
  };

  useEffect(() => {
    if (ref.current) {
      setInputs({
        ...inputs,
        [inputName]: inputs[inputName]
      });
      ref.current.input = {
        ...inputs,
        [inputName]: inputs[inputName]
      };
    }
  }, [isSwipedDown]);

  const onClickBtn = (e) => {
    setError('');
    const value = e === '{bksp}' ? { ...inputs, [inputName]: inputs[inputName]?.slice(0, -1) } : { ...inputs, [inputName]: inputs[inputName] ? inputs[inputName].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      [inputName]: value[inputName]
    });
  };

  return (
    <div>
      <div className="col-12 p-0 large-input">
        {inputOptions && inputOptions.map(({
          name, type, id,
          placeholder
        }) => {
          return (
            <div className={cn('col-12 p-0 my-2 position-relative', inputName === name ? 'border roundedSm od-container-card-border border-color-primary' : '')}>
              <input
                id={id}
                name={name}
                className="col-12 form-control"
                style={{ height: '10vh', fontSize: '5vh' }}
                type={type}
                placeholder={placeholder}
                value={getInputValue(name)}
                onFocus={() => { setKeyboardType('numericAlpha'); handleBlur(id); }}
                onChange={onChangeInput}
              />
              {inputs[inputName]?.length > 0 && (
                <div
                  role="presentation"
                  className="position-absolute"
                  style={{ right: '18px', top: '15px' }}
                  onClick={() => { setEmpty(name); setInputName(name); }}
                >
                  <i className="fa fa-times fs-24 od-text-secondary text-secondary" aria-hidden="true" />
                </div>
              )}
            </div>
          );
        })}
        {error.length > 0 && <div className="text-center fs-12 text-primary">{error}</div>}
        <button
          className={cn('w-100 btn btn-primary btn-ripple od-btn-primary')}
          type="button"
          onClick={() => handleSubmit()}
          style={{ height: '10vh' }}
        >
          <div className="fs-18">{initialData.buttonName}</div>
        </button>
      </div>
      {isSwipedDown && (
        <div className={cn('p-1 background-primary od-app-background-color od-border-secondary ', keyboardType === 'number' || keyboardType === 'numericAlpha' ? Styles.keyboard : Styles.keyboard1)}>
          <CustomKeyboard
            setKeyboardType={setKeyboardType}
            onClickBtn={(e) => onClickBtn(e)}
            type={keyboardType}
            typed={inputs[inputName] || ''}
            closeKeyboard={closeKeyboard}
            btnSize="btn"
            customClass="fs-30 background-primary od-app-background-color"
            maxLength={maxLength}
            buttonTheme={buttonTheme}
          />
        </div>
      )}
    </div>
  );
};

export default MultipleKeyboardInputs;
